module.exports = __webpack_public_path__ + "static/media/LU.df92d45c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LU.svg
// module id = 304
// module chunks = 0